import { api, decodeVaultBlobResponse } from '../api/client';
import { loadVaultSession } from './vaultSession';
import {
  decryptVaultPlaintext,
  encryptVaultPlaintext,
  hasVaultVersionRegression,
  normalizeVaultVersion,
  setStoredVaultVersion,
  type VaultPlaintext,
} from './vault';

export async function persistVaultPlaintext(
  userId: string,
  mutate: (plaintext: VaultPlaintext) => VaultPlaintext,
): Promise<void> {
  const session = loadVaultSession();
  if (!session) {
    throw new Error('vault_locked');
  }

  const blobResponse = await api.getVaultBlob();
  const blob = decodeVaultBlobResponse(blobResponse);
  const serverVersion = Math.max(
    normalizeVaultVersion(blob.vaultVersion),
    normalizeVaultVersion(blobResponse.vaultVersion),
  );
  if (hasVaultVersionRegression(userId, serverVersion)) {
    throw new Error('vault_version_regression');
  }

  const plaintext = await decryptVaultPlaintext(session.vaultKey, blob.vaultBlob);
  const updated = mutate(plaintext);
  const nextVersion = normalizeVaultVersion(updated.vaultVersion) + 1;
  updated.vaultVersion = nextVersion;

  const vaultBlob = await encryptVaultPlaintext(session.vaultKey, updated);
  await api.updateVaultBlob(vaultBlob, nextVersion);
  setStoredVaultVersion(userId, nextVersion);
}

export function seedInfoReplyKeysFromVault(plaintext: VaultPlaintext): void {
  if (!plaintext.infoReplyPriv) {
    return;
  }

  for (const [shareId, privateKey] of Object.entries(plaintext.infoReplyPriv)) {
    sessionStorage.setItem(`shareweb:infoReplyPriv:${shareId}`, privateKey);
  }
}
